import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolders2"><Path d="M7 15V4H11.5L13.5 6H21V15H7Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/><Path d="M3 8V19H17" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolders2;
